<template>
  <OmtLayoutContainer>
    <OmtRow mb="24px"><OmtTypography as="h1-bold"> Nova solicitação </OmtTypography></OmtRow>

    <OmtRow mb="16px">
      <OmtTypography as="p1" color="var(--colors-light-primary-gray2)"> Assunto da solicitação </OmtTypography>
    </OmtRow>

    <OmtRow mb="16px" v-if="!loading">
      <CStack>
        <OmtRow v-for="(opt, idx) in subjectOptionsLocal" :key="`rad-${idx}`">
          <CBox>
            <CFlex justify="space-between" align-items="center" cursor="pointer" mb="8px">
              <OmtRadio
                @click="onSelectSubject(opt.value)"
                :value="String(opt.value)"
                :isChecked="selectedSubject === opt.value"
                :reverse="true"
                name="subject"
              >
                <OmtTypography as="p1">{{ opt.label }}</OmtTypography>
              </OmtRadio>
            </CFlex>
          </CBox>
        </OmtRow>
      </CStack>
    </OmtRow>

    <OmtRow mb="8px" v-if="!loading">
      <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
        Beneficiário que realizará o procedimento
      </OmtTypography>
    </OmtRow>

    <OmtRow v-if="!loading">
      <Options
        id="optRecipientId"
        name="optRecipient"
        :solid="true"
        :preSelected="beneficiary"
        :options="beneficiaries"
        :onSelection="onSelectedBeneficiary"
        placeholder="Selecione o Beneficiário"
        class="options-requests"
      />
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="next" :disabled="disableButton">Continuar</OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Options from "@/components/Molecules/Options";

export default {
  name: "CreateRequest",
  components: { Options },
  data() {
    return {
      beneficiary: "",
      loading: true,
      selectedSubject: 0,
      subjectOptionsLocal: []
    };
  },
  computed: {
    ...mapState("request", ["addPermission", "beneficiaries", "newRequest"]),
    disableButton() {
      const hasSubject = !!this.selectedSubject;
      const beneficiaryRequired = this.beneficiaries && this.beneficiaries.length > 0;
      if (!hasSubject) return true;
      if (beneficiaryRequired && !this.beneficiary) return true;
      return false;
    }
  },
  methods: {
    ...mapActions("request", ["fetchBeneficiaries"]),
    ...mapMutations("request", ["SET_BENEFICIARY", "SET_SUBJECT"]),
    ...mapMutations("programasSaude", ["SET_NEW_SOLICITATION"]),
    onSelectedBeneficiary(beneficiary) {
      this.beneficiary = beneficiary || "";
    },

    onSelectSubject(value) {
      const num = Number(value);
      if (!Number.isNaN(num)) this.selectedSubject = num;
    },

    next() {
      const selected = this.subjectOptionsLocal.find(s => s.value === this.selectedSubject) || {};
      this.SET_NEW_SOLICITATION({
        tipoSolicitacao: this.selectedSubject,
        beneficiario: this.beneficiary,
        autenticacao: selected.autenticacao ?? 0
      });
      this.$router.push({ name: "programas-saude-term" });
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      this.loading = true;
      if (!this.addPermission) this.$router.replace("/solicitacoes");

      await this.fetchBeneficiaries();

      const tipos = await this.$store.dispatch("programasSaude/fetchTiposSolicitacao");
      this.subjectOptionsLocal = (tipos || []).map(t => ({
        value: t.Id || t.id_tipoSolicitacao || 0,
        label: t.Nome || t.ds_abreviada || "Programa de Saúde",
        tipoAnexo: t.TipoAnexo || "",
        prazoAnalise: t.PrazoAnalise ?? null,
        prazoPendencia: t.PrazoPendencia ?? null,
        autenticacao: t.Autenticacao ?? t.AutenticacaoServer ?? 0
      }));

      if (this.newRequest?.subject) {
        const subj = Number(this.newRequest.subject);
        if (!Number.isNaN(subj) && subj > 0) {
          this.selectedSubject = subj;
        }
      } else {
        const defaultOption = this.subjectOptionsLocal.find(opt => {
          const label = String(opt.label || "").toLowerCase();
          return label === "programas de saúde" || label.includes("programas de saúde");
        });

        if (defaultOption) {
          this.selectedSubject = defaultOption.value;
        } else if (this.subjectOptionsLocal.length === 1) {
          this.selectedSubject = this.subjectOptionsLocal[0].value;
        }
      }

      if (this.newRequest?.beneficiary) this.onSelectedBeneficiary(this.newRequest.beneficiary);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.round-radios {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.round-radio {
  display: flex;
  align-items: center;
  gap: 12px;
}
.round-radio input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--colors-light-secondary-divider, #cfcfcf);
  cursor: pointer;
}
.round-radio input[type="radio"]:checked {
  background-color: var(--colors-light-primary-navy-blue, #172972);
  border-color: var(--colors-light-primary-navy-blue, #172972);
}
.round-radio label {
  cursor: pointer;
  user-select: none;
}
</style>
